module.exports = __webpack_public_path__ + "static/media/seen.092f6aa1.svg";